<template lang="pug">
span
	a.a-icon-image.icon-short(@click="showHelp", v-if="!hidden")
	b-modal#modal1(v-model="showDialog" hide-footer size="lg" title="")
		.canvas-border
			// div(v-if="isAdmin")
				p: a(@click="editHelp") Edit this help screen

			div(v-html="helpObj.helpText", v-if="!editing")
			b-form-textarea(:rows="5", v-model="helpObj.helpText",  v-if="editing")

			.content-btn(style="width: 100%; display: flex; justify-content:center;")

				a(@click="hideHelp", v-if="!editing")
					easyBtn(btnText="Close")

				a(@click="save", v-if="editing")
					easyBtn(btnText="Save")

				a(@click="editHelp", v-if="isAdmin && !editing")
					easyBtn(btnText="Edit")

				a(@click="hideHelp", v-if="isAdmin && editing")
					easyBtn(btnText="Cancel")
</template>

<script>
// import Vue from 'vue'
import _ from 'lodash'
import easyBtn from './easy-btn.vue'
import {Role} from 'janux-authorize'

export default {
	name: 'help-button',
	props: ['id', 'hidden'],
	data () {
		return {
			helpObj: {},
			showDialog: false,
			editing: false,
			currentLogin: false
		}
	},
	components: { easyBtn },
	computed: {
		isAdmin: function () {
			return (this.currentLogin.status && this.currentLogin.role.isAlmighty)
		}
	},
	created () {
		this.$e24Common.security.getSharedLoginStatus().then((status) => {
			// console.log('currentLogin', status.status, ' role is ', status.role)
			this.currentLogin = status
			if (this.currentLogin.status) {
				this.currentLogin.role = Role.fromJSON(status.role)
				// console.log('Hidrated role', this.currentLogin.role, this.currentLogin.role.can('UPDATE', 'ORDER'))
			}
			this.ready = true
		})
	},
	methods: {
		showHelp () {
			// console.log('this.$e24Common.helpService', this.id)
			if (_.isNil(this.helpObj.id)) {
				// console.log('this.$e24Common. ', this.$e24Common.helpService.findHelpById(2503))
				this.$e24Common.helpService.findHelpById(this.id).then((helpObj) => {
					if (_.isNil(helpObj)) {
						helpObj = {
							question: '',
							helpText: 'Help text ' + this.id + ' not found.'
						}
					}

					this.helpObj = helpObj
					// console.log('helpObj', helpObj)
				})
			}
			this.showDialog = true
		},
		hideHelp () {
			this.editing = false
			this.showDialog = false
		},
		editHelp () {
			this.editing = true
		},
		save () {
			this.$e24Common.helpService.update(this.helpObj).then(() => {
				this.$notify({
					group: 'app',
					type: 'info',
					title: '',
					text: 'Help text successfully saved!',
					duration: 900
				})
				this.editing = false
				this.showDialog = false
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/components/help-button.vue